// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ItemMedia__container-c43626 {
  margin: 8px 0;
  display: flex;
  flex: 0 0 auto;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/MediaMessagePopup/ItemMedia/ItemMedia.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;AACF","sourcesContent":[".container {\n  margin: 8px 0;\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ItemMedia__container-c43626`
};
module.exports = ___CSS_LOADER_EXPORT___;
